/**
 * As per Sentry's documentation[1] this should always be imported first to
 * ensure we initialise the Sentry SDK as early as possible.
 *
 * [1]: https://docs.sentry.io/platforms/javascript/guides/react/#configure
 */
import "./instrument";
import "core-js";
import "regenerator-runtime/runtime";
import { App } from "./App";
import React from "react";
import ReactDOM from "react-dom";
ReactDOM.render(<App />, document.getElementById("main"));